<template>
    <v-container fluid>
        <div style="width: 100%">
            <v-row v-if="amountGiftWarning" class="d-flex justify-center py-1">
                <v-col :cols="$vuetify.display.mobile ? '12' : '12'" class="my-0 pa-2">
                    <v-row>
                        <v-col :cols="$vuetify.display.mobile ? '12' : '1'">
                            <div class="d-flex align-center justify-start ml-5 mt-5">
                                <v-btn-back @click="$router.go(-1)"> </v-btn-back>
                            </div>
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? '12' : '10'">
                            <oss-card :icon="'$fa-exclamation-triangle'" :icon-color="'new_red'">
                                <v-row no-gutters>
                                    <v-col style="d-flex align-center justify-center">
                                        <v-row>
                                            <span
                                                class="d-flex align-center justify-center ml-5"
                                                style="font-weight: bold; font-size: 12pt"
                                            >
                                                Le prix de revient ou d'achat du cadeau offert est
                                                de 69 &#x20ac; TTC maximum par an et par
                                                bénéficiaire.
                                            </span>
                                            <span
                                                class="d-flex align-center justify-center ml-5"
                                                style="font-weight: bold; font-size: 12pt"
                                            >
                                                Si les cadeaux clients déductibles atteignent 3
                                                000&#x20ac; par an, il ne faut surtout pas omettre
                                                de remplir la déclaration n&#xb0;2067 (relevé des
                                                frais généraux <br />
                                                pour les sociétés) ou le cadre F de la déclaration
                                                n&#xb0;2031 (pour les entreprises individuelles) de
                                                la liasse fiscale.
                                            </span>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </oss-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row
                v-for="item in items"
                :key="item.id"
                class="d-flex justify-center py-1"
                style="height: fit-content"
            >
                <v-col
                    :cols="$vuetify.display.mobile ? '12' : '10'"
                    class="pa-0 d-flex justify-center"
                    @click="openDocument(item)"
                    style="cursor: pointer"
                >
                    <oss-card
                        :icon="'trending_down'"
                        :icon-color="'new_red'"
                        :tag-text="callToActionText(item)"
                        :tag-style="'elevation-0 pa-1 mr-2'"
                        :outlined-tag="false"
                        :amount="item.amount"
                        :amount-style="
                            $vuetify.display.mobile
                                ? 'font-weight-black align-center justify-center'
                                : 'title font-weight-black'
                        "
                        rounded-tag
                        @click:tag="openDocument(item)"
                    >
                        <template #left>
                            <v-row v-if="$vuetify.display.mobile" no-gutters>
                                <v-col class="d-flex align-center primary--text pt-2 pl-2">
                                    <span style="white-space: nowrap; overflow: hidden">{{
                                        item.name
                                    }}</span>
                                </v-col>
                                <v-col class="d-flex overline pb-2 pl-2">
                                    <span>
                                        <v-icon color="secondary" size="small" location="start"
                                            >$oss-calendar</v-icon
                                        >
                                        {{ getDateFormated(item) }}
                                    </span>
                                </v-col>
                            </v-row>
                            <v-row v-else no-gutters style="height: fit-content">
                                <v-col style="d-flex align-center">
                                    <v-row>
                                        <span
                                            style="
                                                font-weight: bold;
                                                font-size: 12pt;
                                                white-space: nowrap;
                                                overflow: hidden;
                                            "
                                        >
                                            {{ item.name }}
                                        </span>
                                    </v-row>
                                    <v-row>
                                        <span v-if="checkAmountGiftWarning(item)">
                                            <v-icon size="small" color="new_red" left
                                                >$fa-exclamation-triangle</v-icon
                                            >
                                        </span>
                                    </v-row>
                                </v-col>
                                <v-col style="max-width: fit-content">
                                    <span v-if="item.date">
                                        <v-icon color="secondary" size="small" location="start"
                                            >$oss-calendar</v-icon
                                        >
                                        {{ getDateFormated(item) }}
                                    </span>
                                </v-col>
                            </v-row>
                        </template>
                    </oss-card>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script lang="ts">
import gql from "graphql-tag";
import moment from "moment-timezone";

import { Apollo } from "@/decorators";

import GIFTS_CHECK from "../../graphql/audit/AuditItems.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component
export class CheckVATGift extends Vue {
    amountGiftWarning: boolean = false;

    getDateFormated(gift) {
        const date = gift.date || gift.dateAuto;
        if (date) {
            return moment(date).format("DD/MM/YYYY");
        }
        return "";
    }

    checkAmountGiftWarning(item) {
        if (item.amount > 69) {
            this.amountGiftWarning = true;
            return true;
        }
        return false;
    }

    callToActionText(item) {
        if (this.checkAmountGiftWarning(item)) {
            return "A vérifier";
        }

        return "Détail";
    }

    get companyId() {
        return this.$store.state.selected_company.id;
    }

    openDocument(gift) {
        this.$router.push({
            name: "document",
            params: {
                companyId: this.companyId,
                id: gift.giftId,
            },
        });
    }

    get auditCheck() {
        return this.$route.params.auditCheck;
    }

    @Apollo({
        query: GIFTS_CHECK,
        variables() {
            return {
                companyId: this.companyId,
                auditCheck: this.auditCheck,
            };
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.items = data.auditItems.items;
                }
            }
        },
    })
    items: Array<any> = [];
}

export default toNative(CheckVATGift);
</script>
